import styled from "styled-components";
import { FontMixin } from "../../../../../../../../styles/common/mixins/helpers.styled.js";
export const Content = styled.div.withConfig({
    displayName: "styled__Content",
    componentId: "sc-8764bd70-0"
})`
	padding: ${({ $fullWidth  })=>$fullWidth ? '0' : '0 16px'};
`;
export const ExtraInfo = styled.div.withConfig({
    displayName: "styled__ExtraInfo",
    componentId: "sc-8764bd70-1"
})`
	${FontMixin({
    size: 'medium',
    weight: 'regular'
})}
	line-height: 18px;
	color: ${({ theme  })=>theme.colors.text};
	background-color: ${({ theme  })=>theme.colors.primary.lightestL};
	padding: 13px 50px 11px 12px;
	border-bottom: 1px solid ${({ theme  })=>theme.border.color.light};
	border-top: 1px solid ${({ theme  })=>theme.border.color.light};
`;

//# sourceMappingURL=styled.js.map